import { Action } from '@ngrx/store';

export const LOGIN = 'LOGIN';
export const REGISTER = 'REGISTER';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export class LoginAction implements Action {
  readonly type = LOGIN;

  constructor() {}
}

export class LoginSuccessAction implements Action {
  readonly type = LOGIN_SUCCESS;

  constructor(public payload: string) {}
}

export class LoginFailedAction implements Action {
  readonly type = LOGIN_FAILED;

  constructor(public payload: string) {}
}

export class LogoutAction implements Action {
  readonly type = LOGOUT;

  constructor() {}
}

export class LogoutSuccessAction implements Action {
  readonly type = LOGOUT_SUCCESS;

  constructor() {}
}

export type Actions = LoginAction | LoginSuccessAction | LoginFailedAction | LogoutAction | LogoutSuccessAction;
